export default "__VITE_ASSET__DVyBF905__"